import type { PrerequisiteRow } from '../../devenvbootstrap/framework';

type Props = { items?: PrerequisiteRow[] };

export function PrerequisitesPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.tool} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{item.tool}</p>
              <p className="font-mono text-xs text-slate-500">{item.check}</p>
            </div>
            <div className="text-right">
              <p className="text-xs text-slate-500">{item.version}</p>
              {item.required && (
                <span className="rounded-full bg-brand-50 px-2 py-0.5 text-xs font-medium text-brand-700 dark:bg-brand-950 dark:text-brand-300">
                  required
                </span>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
